import {EImagePickerError} from './definitions';

export default {
  uploadImage: 'Upload from computer',
  uploadByUrl: 'Enter the file link',
  imageDimensions: '{{width}} x {{height}} px',
  imageInfo: '{{format}} image {{size}}',
  urlLabel: 'File URL',
  loading: "Hold on, we're uploading the image...",
  imageError: 'Image upload error: {{error}}',
  invalidUrl: 'Wrong URL pattern',
  loadingByUrlError: 'Error loading file',
  errors: {
    [EImagePickerError.FORMAT]: 'invalid format',
    [EImagePickerError.ACCEPT]: 'allowed file format is {{formats}}',
    [EImagePickerError.SIZE]: 'minimum image size is {{size}}',
    [EImagePickerError.DIMENSIONS]: 'maximum file size is {{width}}x{{height}}px',
  },
};
